import {useState} from 'react';
import StudiesProvider from '@/providers/studies';

const useRequestInfo = () => {
    const [isOpen, setIsOopen] = useState( false );
    const [requestClaimDetail, setRequestClaimDetail] = useState( {} );
    const [error, setError] = useState( null );
    const [isProcessing, setIsProcessing] = useState( false );
    const toggleRequestInfo = () => {
        if ( isOpen ) {
            setRequestClaimDetail( {} );
            setError( null );
        }
        setIsOopen( prev => !prev )
    };

    function onOpenRequestInfo ( {claimId, claimTitle} ) {
        console.log( 'handle claim info', claimId, claimTitle );
        setRequestClaimDetail( {claimId, claimTitle} );
        toggleRequestInfo();
    }

    async function onSubmitInquiry ( inquiry ) {
        setIsProcessing( true );
        setError( null );
        try {
            await StudiesProvider.requestInfoForClaim( {
                ...requestClaimDetail,
                inquiry
            } )

            console.log( `Request Information submission for claim submitted!`, requestClaimDetail );
            toggleRequestInfo();
        }
        catch ( error ) {
            const errorData = error.response?.data ?? error;
            console.error( '[Error] Request Information submission failed', errorData );
            setError( errorData );
        }
        setIsProcessing( false );
    }

    return {
        isOpen,
        toggleRequestInfo,
        onOpenRequestInfo,
        submitRequest: onSubmitInquiry,
        isProcessing,
        description: requestClaimDetail.claimTitle || '',
        error
    };
}

export default useRequestInfo;
